import { Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import RefuseSelect from '../RefuseSelect';
import './styles.scss';

const getFileExtension = (filename: any) => {
  if (!filename || typeof filename !== 'string') {
    return '';
  }
  const parts = filename.split('.');
  return parts.length > 1 ? parts.pop()?.toLowerCase() || '' : '';
};

const CrlvComponent: React.FC = () => {
  const { crlv } = useSelector(
    (state: ApplicationState) => state.driver?.vehicle,
  );

  const showContent = () => {
    if (crlv?.imageUrl && crlv.imageUrl.length > 0) {
      const extension = getFileExtension(crlv.imageUrl);
      if (extension === 'pdf') {
        return <iframe src={crlv.imageUrl} width="350px" />;
      } else if (
        extension === 'jpg' ||
        extension === 'jpeg' ||
        extension === 'png'
      ) {
        return <img src={crlv.imageUrl} alt="crlv" width="350px" />;
      }
    }
    return <Typography variant="body1">Sem imagem</Typography>;
  };

  return (
    <div style={{ display: 'flex' }}>
      <div className="crlv-container">{showContent()}</div>
      <RefuseSelect step={4} />
    </div>
  );
};

export default CrlvComponent;
